import { SCLA_APPLICATION_SECTIONS } from './sections';

/** Home checklist order. Step tabs keep the order in SCLA_APPLICATION_SECTIONS. */
const HOME_SECTION_IDS = [
  'background',
  'family',
  'school',
  'prompts',
  'transcripts',
  'rec',
  'signature',
] as const;

export const SCLA_HOME_SECTION_COUNT = HOME_SECTION_IDS.length;

const HOME_LABELS: Record<(typeof HOME_SECTION_IDS)[number], string> = {
  background: 'Background info',
  family: 'Family info',
  school: 'School info',
  prompts: 'Short response prompts',
  transcripts: 'Transcripts',
  rec: 'Letter of recommendation',
  signature: 'Sign & submit',
};

export function sclaHomeChecklist() {
  return HOME_SECTION_IDS.map(id => {
    const section = SCLA_APPLICATION_SECTIONS.find(item => item.id === id);
    if (!section) {
      throw new Error(`Missing SCLA section ${id}`);
    }
    return {
      id,
      label: HOME_LABELS[id],
      optional: id === 'rec',
      to: section.to,
      getComplete: section.getComplete,
    };
  });
}
